module.exports = __webpack_public_path__ + "static/media/misuse-of-it-systems.682e19e3.svg";